import { styled } from '@linaria/react';

export const AnimatedContent = styled.span`
	@keyframes animated-number-pulse {
		0%,
		100% {
			transform: scale(1);
			filter: drop-shadow(0) brightness(1);
		}
		50% {
			transform: scale(1.3);
			filter: drop-shadow(0 0 4px var(--color-white-06)) brightness(1.5);
		}
	}

	display: flex;

	animation-iteration-count: var(--anim-repeat);
	animation-name: animated-number-pulse;
	animation-duration: var(--anim-duration);
`;
